import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		sliderContainer: {
			padding        : "2rem",
			display        : "flex",
			alignItems     : "center",
			justifyContent : "end"
		},
		sliderBar: {
			marginLeft   : "2rem",
			marginRight  : "2rem",
			marginBottom : "0",
			width        : "50%"
		},
		svgIconSmall: {
			...theme.other.svgIcons.size10
		},
		svgIconBig: {
			...theme.other.svgIcons.size25
		},
		reselectButton: {
			"&:hover": {
				boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.16)"
			},
			padding      : "0.5rem 1rem",
			cursor       : "pointer",
			borderRadius : "6px"
		},
		reselectButtonText: {
			color: theme.other.paletteNew.primaryLightBlue

		},
		saveButton: {
			padding    : "0.5rem 2rem",
			background : theme.other.paletteNew.mainGradient,
			marginLeft : "1rem"
		},
		sliderTrack: {
			backgroundColor: "#439aff"
		},
		sliderThumb: {
			backgroundColor : "#fff",
			border          : "2px solid #439aff"
		},
		reselectSaveCtn: {
			display    : "flex",
			alignItems : "center",
			gap        : "1rem"
		},
		submitBtn: {
			float: "right"
		}
	};
} );
